import {Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {Observable, Subscription} from 'rxjs';
import {Offset} from '../../models/Offset';
import {GenericArray} from '../../models/GenericArray';
import {DialogDetailComponent} from '../general-components/dialog-detail/dialog-detail.component';
import {UsersService} from './service/users.service';
import {UserModel} from '../../models/UserModel';
import {LoaderService} from '../general-services/service-loader/loader.service';
import {Router} from '@angular/router';
import {BaseGeneralComponent} from '../BaseGeneralComponent';
import {urls} from 'src/services/api/urls';
import * as servers from '../../services/api/servers';
import * as toastr from 'toastr';
import {ProjectConstants} from '../project-constants';
import {HttpClient} from '@angular/common/http';


@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  sectionId: string;
  enableUpdatePlains: boolean;
  listRowSelected: any;

  displayedColumns: Array<string>;
  dataSource: UserModel[];
  listData: MatTableDataSource<any>;
  getAllSubscribe: Subscription;
  deleteElementSubscribe: Subscription;
  offset: Offset;
  showFilter: boolean;
  filter: any;
  filterContainer: any;
  pageSize: number;
  selectedRowIndex: number;
  isUserSection: boolean;

  updateAllPlains: Subscription;


  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  @Output() elementSelected = new EventEmitter();

  constructor(private usersService: UsersService,
              private loaderService: LoaderService,
              private dialog: MatDialog,
              private router: Router,
              private httpClient: HttpClient) {
    super();
    this.sectionId = this.SECTIONS.USER_SETTINGS;
    this.user = JSON.parse(sessionStorage.getItem('user'));
  }

  ngOnInit() {
    this.isUserSection = this.returnIsContractSection(this.router.url);
    this.displayedColumns = ['Username', 'Name', 'Surname', 'Mail', 'Active', 'Notification', 'Role', 'actions'];
    this.pageSize = +this.PAGINATOR.PAGE_SIZE_ARRAY[0];
    this.listRowSelected = [];
    this.enableUpdatePlains = false;

    this.selectedRowIndex = -1;
    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.USER_OFFSET);
    this.usersService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
    this.getAll(this.offset);
  }

  getAll(offset: Offset) {
    this.loaderService.display(true);
    this.getAllSubscribe = this.usersService.getPage(offset, this.filter)
      .subscribe(
        (result: any) => {
          this.dataSource = result.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = result.totalElements;
          this.loaderService.display(false);
        }
      );
  }

  openDialog(id: number) {
    this.getUserById(id)
      .subscribe((res: UserModel) => {
        let localCustomerListString = '';
        let providerListString = '';
        let regionListString = '';
        let contractTypeListString = '';

        for (let _i = 0; _i < res.localCustomerList.length; _i++) {
          const comma = _i === res.localCustomerList.length - 1 ? '' : ' ,';
          localCustomerListString += res.localCustomerList[_i].description + comma;
        }
        for (let _i = 0; _i < res.providerList.length; _i++) {
          const comma = _i === res.providerList.length - 1 ? '' : ' ,';
          providerListString += res.providerList[_i].description + comma;
        }
        for (let _i = 0; _i < res.regionList.length; _i++) {
          const comma = _i === res.regionList.length - 1 ? '' : ' ,';
          regionListString += res.regionList[_i].description + comma;
        }
        for (let _i = 0; _i < res.contractTypeList.length; _i++) {
          const comma = _i === res.contractTypeList.length - 1 ? '' : ' ,';
          contractTypeListString += res.contractTypeList[_i].description + comma;
        }

        const list: GenericArray[] = [
          {id: 'Domain User', value: res.username.toString()},
          {id: 'Name', value: res.name.toString()},
          {id: 'Surname', value: res.surname.toString()},
          {id: 'Email', value: res.mail.toString()},
          {id: 'Active', value: res.active},
          {id: 'Notification', value: res.timetableNotification},
          {id: 'Role', value: res.roleList[0]},
          {id: 'Associated Local Customer List', value: res.localCustomerList.length > 0 ? localCustomerListString : 'N.D.'},
          {id: 'Associated Provider List', value: res.providerList.length > 0 ? providerListString : 'N.D.'},
          {id: 'Associated Region List', value: res.regionList.length > 0 ? regionListString : 'N.D.'},
          {id: 'Associated Contract Type List', value: res.contractTypeList.length > 0 ? contractTypeListString : 'N.D.'}
        ];

        const dialogRef = this.dialog.open(DialogDetailComponent, {
          width: '40%',
          data: {list}
        });

        dialogRef.afterClosed().subscribe(result => {
          // console.log('The dialog was closed');
        });
      });
  }

  editUser(id: number) {
    this.getUserById(id)
      .subscribe((res: UserModel) => {
        this.usersService.editUser = res;
        this.router.navigate([this.LINKS.EDIT_USERS]);
      });
  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.USER_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getAll(this.offset);
  }

  deleteElement(id: number) {
    if (confirm('Are you sure do you want to delete?')) {
      this.deleteElementSubscribe = this.usersService.softDelete(id)
        .subscribe(
          (result: any) => {
            if (result) {
              this.getAll(this.offset);
            } else {
            }
          }
        );
    }
  }

  getDataFiltered(dataFiltered: any) {
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    this.filter = dataFiltered;
    this.getAll(this.offset);

  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getAll(this.offset);
    }

  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({row});
  }

  ngOnDestroy(): void {
    if (this.getAllSubscribe) {
      this.getAllSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
    if (this.updateAllPlains) {
      this.updateAllPlains.unsubscribe();
    }
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  private getUserById(id: number): Observable<UserModel> {
    const selectedUser = this.dataSource.find(data => data.id === id) as UserModel;
    const url = servers.apiUrl + urls.users + this.LINKS.GET_USER_BY_USERNAME;
    const body = JSON.stringify(selectedUser);
    const header = ProjectConstants.returnGeneralHeader();
    return this.httpClient.post<UserModel>(url, body, {headers: header, responseType: 'json'});
  }

  changeTimetableNotification(element) {
    this.enableUpdatePlains = true;
    const existingValue: UserModel = this.listRowSelected.find(ex => ex.id === element.id);
    if (existingValue) {
      existingValue.timetableNotification =
        element.timetableNotification === false ? element.timetableNotification = true : element.timetableNotification = false;
      this.listRowSelected = this.listRowSelected.filter(fil => fil.id !== existingValue.id);
      this.listRowSelected.push(existingValue);
    } else {
      element.timetableNotification =
        element.timetableNotification === 0 ? element.timetableNotification = 1 : element.timetableNotification = 0;
      this.listRowSelected.push(element);
    }
    this.listData.data.forEach(value => {
      if (value.id === element.id) {
        value = this.listRowSelected.find(value1 => value1.id === element.id);
      }
    });
  }

  changeActive(element) {
    this.enableUpdatePlains = true;
    const existingValue: UserModel = this.listRowSelected.find(ex => ex.id === element.id);
    if (existingValue) {
      existingValue.active =
        element.active === false ? element.active = true : element.active = false;
      this.listRowSelected = this.listRowSelected.filter(fil => fil.id !== existingValue.id);
      this.listRowSelected.push(existingValue);
    } else {
      element.active =
        element.active === 0 ? element.active = 1 : element.active = 0;
      this.listRowSelected.push(element);
    }
    this.listData.data.forEach(value => {
      if (value.id === element.id) {
        value = this.listRowSelected.find(value1 => value1.id === element.id);
      }
    });
  }

  updateClaims() {
    this.updateAllPlains = this.usersService.updateAllClaims(this.listRowSelected)
      .subscribe(
        () => {
          this.enableUpdatePlains = false;
          toastr.success('Plains updated with success', 'Success');
          this.getAll(this.offset);
        }, () => {
          toastr.error('A problem has occurred, please contact the Administrator', 'Error');
        }
      );
    this.listRowSelected = [];
    this.enableUpdatePlains = false;
  }

}
